/* tslint:disable */
/* eslint-disable */
/**
 * WICSSend
 * API reference documentation for WICSSend
 *
 * The version of the OpenAPI document: 0.1.0-RC
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Company } from '../model';
// @ts-ignore
import type { CompanyResponse } from '../model';
/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [cursor] The current page
         * @param {number} [length] The pagesize
         * @param {string} [search] A search parameter to filter on company name
         * @param {number} [year] A year parameter to filter the label count
         * @param {number} [month] A month parameter to filter the label count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppCompanyList: async (cursor?: number, length?: number, search?: string, year?: number, month?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                for (const [key, value] of Object.entries(cursor)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (length !== undefined) {
                for (const [key, value] of Object.entries(length)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (year !== undefined) {
                for (const [key, value] of Object.entries(year)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (month !== undefined) {
                for (const [key, value] of Object.entries(month)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppCompanyPost: async (company?: Company, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [cursor] The current page
         * @param {number} [length] The pagesize
         * @param {string} [search] A search parameter to filter on company name
         * @param {number} [year] A year parameter to filter the label count
         * @param {number} [month] A month parameter to filter the label count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppCompanyList(cursor?: number, length?: number, search?: string, year?: number, month?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppCompanyList(cursor, length, search, year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getAppCompanyList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAppCompanyPost(company?: Company, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAppCompanyPost(company, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.postAppCompanyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)
    return {
        /**
         * 
         * @param {CompanyApiGetAppCompanyListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppCompanyList(requestParameters: CompanyApiGetAppCompanyListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAppCompanyList(requestParameters.cursor, requestParameters.length, requestParameters.search, requestParameters.year, requestParameters.month, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyApiPostAppCompanyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppCompanyPost(requestParameters: CompanyApiPostAppCompanyPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CompanyResponse> {
            return localVarFp.postAppCompanyPost(requestParameters.company, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAppCompanyList operation in CompanyApi.
 * @export
 * @interface CompanyApiGetAppCompanyListRequest
 */
export interface CompanyApiGetAppCompanyListRequest {
    /**
     * The current page
     * @type {number}
     * @memberof CompanyApiGetAppCompanyList
     */
    readonly cursor?: number

    /**
     * The pagesize
     * @type {number}
     * @memberof CompanyApiGetAppCompanyList
     */
    readonly length?: number

    /**
     * A search parameter to filter on company name
     * @type {string}
     * @memberof CompanyApiGetAppCompanyList
     */
    readonly search?: string

    /**
     * A year parameter to filter the label count
     * @type {number}
     * @memberof CompanyApiGetAppCompanyList
     */
    readonly year?: number

    /**
     * A month parameter to filter the label count
     * @type {number}
     * @memberof CompanyApiGetAppCompanyList
     */
    readonly month?: number
}

/**
 * Request parameters for postAppCompanyPost operation in CompanyApi.
 * @export
 * @interface CompanyApiPostAppCompanyPostRequest
 */
export interface CompanyApiPostAppCompanyPostRequest {
    /**
     * 
     * @type {Company}
     * @memberof CompanyApiPostAppCompanyPost
     */
    readonly company?: Company
}

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * 
     * @param {CompanyApiGetAppCompanyListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getAppCompanyList(requestParameters: CompanyApiGetAppCompanyListRequest = {}, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).getAppCompanyList(requestParameters.cursor, requestParameters.length, requestParameters.search, requestParameters.year, requestParameters.month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyApiPostAppCompanyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public postAppCompanyPost(requestParameters: CompanyApiPostAppCompanyPostRequest = {}, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).postAppCompanyPost(requestParameters.company, options).then((request) => request(this.axios, this.basePath));
    }
}

